function attachPersonalisationHandler() {
  const productForm = document.querySelector('form[action="/cart/add"]');
  if (!productForm) {
    console.warn("🛑 No product form found.");
    return;
  }

  // Prevent attaching multiple times
  if (productForm.dataset.personalisationAttached === "true") return;
  productForm.dataset.personalisationAttached = "true";

  productForm.addEventListener('submit', function (event) {
    event.preventDefault();

    const idInput = productForm.querySelector('input[name="id"]');
    const personalizationInput = productForm.querySelector('input[name="properties[Personalisation]"]');
    const quantityInput = productForm.querySelector('input[name="quantity"]');

    const productId = idInput?.value;
    const personalization = personalizationInput?.value || '';
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

    if (!productId) {
      alert("Please select a product variant.");
      console.warn("⚠️ No valid product ID found");
      return;
    }

    console.log("📝 Submitting to cart with:");
    console.log("ID:", productId);
    console.log("Qty:", quantity);
    console.log("Personalisation:", personalization);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: productId,
        quantity: quantity,
        properties: {
          Personalisation: personalization
        }
      })
    })
    .then(response => {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    })
    .then(data => {
      console.log("✅ Successfully added to cart:", data);
      window.location.href = '/cart';
    })
    .catch(error => {
      console.error('❌ Add to cart error:', error);
      alert('Could not add to cart. Please try again.');
    });
  });
}

// Wait a bit to ensure DOM is fully loaded
setTimeout(() => {
  console.log("✅ personalisation.js loaded – attaching handler");
  attachPersonalisationHandler();
}, 300);